module.exports = __webpack_public_path__ + "static/media/icon_in.cf10bbbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/icon_in.svg
// module id = 40
// module chunks = 0